// Imports
  // React
  import { useState, useEffect } from 'react'
  // Firebase
  import { getItems } from "../firebase/FirebaseClient"
  // Components
  import ItemCard from '../components/ItemCard'
  // Icons
  import { BiSearchAlt } from "react-icons/bi"
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faSortDown } from "@fortawesome/free-solid-svg-icons"




//rafce

const Productos = () => {


  // Buscador
  const [term, setTerm] = useState("")
  
  const searchingTerm = (term) => { 
    return function(x){
      const termLow = term.toLowerCase()
      return x.code.toLowerCase().includes(termLow) ||
             x.name.toLowerCase().includes(termLow) ||
             x.description.toLowerCase().includes(termLow) ||
             !term;
    }
  }


  // Get items from Firebase
  const [items, setItems] = useState(JSON.parse(sessionStorage.getItem('storagedProductos')) || []);

  useEffect(() => {
    if(items.length === 0){
      getItems().then( data => {
        setItems(data)
      })
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    }
    else{
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    }
  }, [])

  // Listar items
  function listItems(){
    // Set session storage
    sessionStorage.setItem('storagedProductos', JSON.stringify(items))
    // Mostrarlos
    return(
      <div className='item-list-container'>
        {
          items.filter(searchingTerm(term)).map( i =>
            <div className="product-card" key={i.id}>
              <ItemCard item={i} />
            </div>
          )
        }
      </div>
    )
  }


  // Manejar Filtros

    // Botón de filtros
    let menuClosed = true;
	  const filterOptions = () => {
		  const filterMenu = document.getElementsByClassName('item-filter-options')[0];
      if(menuClosed){
        menuClosed = false;
        filterMenu.classList.add('display-flex');
      }
      else{
        menuClosed = true;
        filterMenu.classList.remove('display-flex');
      }
    }
    // Click en una opción
    const linkHandler = () => {
      const filterMenu = document.getElementsByClassName('item-filter-options')[0];
      filterMenu.classList.remove('display-flex');
      menuClosed = true;
    }


    // Chekboxes
    const [categorySelected, setCategorySelected] = useState("")
    const [categoryFiltered, setCategoryFiltered] = useState([])

    const handleOnCheckbox = e => {
      setCategorySelected({
        ...categorySelected,
        [e.target.value]: e.target.checked,
      });

      if(e.target.checked){
        const categoryResult = items.filter( i => i.category.indexOf(e.target.value) !== -1 )
        
        const result = [ ...categoryFiltered, ...categoryResult ]
        const resultFiltered = result.filter((item,index)=>{
          return result.indexOf(item) === index;
        })

        resultFiltered.sort(function(a, b){
          if(a.code < b.code) {return -1;}
          if(a.code > b.code) {return 1;}
          return 0;
        });

        setCategoryFiltered(
          resultFiltered
        );

      }

      else{
        const categoryResult = categoryFiltered.filter( i => i.category.indexOf(e.target.value) === -1 )
        
        setCategoryFiltered([
          ...categoryResult
        ])

        //Ver los otros checkboxes
        const checkboxes = document.querySelectorAll('input[type=checkbox]')
        for(let i=0; i<checkboxes.length; i++){
          if(checkboxes[i].checked === true){
            const prev = checkboxes[i].value
            const itemsPrev = categoryFiltered.filter( i => i.category.indexOf(prev) !== -1 )
            setCategoryFiltered(itemsPrev)
          }

        }


      }

    }
    
    // Listar productos filtrados
    function filteredItems(){
      return(
        <div className='item-list-container'>
          {
            categoryFiltered.filter(searchingTerm(term)).map( i =>
              <div className="product-card" key={i.id}>
                <ItemCard item={i} />
              </div>
            )
          }
        </div>
      )
    }




	// Component
  return (
    <div className='main-items'>
      <div className='main-items-fixed'>
        <div className='item-search'>
          <input type="text"
                name="term"
                placeholder="Buscador..."
                onChange={e => setTerm(e.target.value)} />
          <BiSearchAlt />
        </div>
        <div className='item-filter'>
          <button className="item-filter-button" onClick={filterOptions}>
            Filtrar<FontAwesomeIcon icon={ faSortDown } size="2x" />
          </button>
          <ul className='item-filter-options'>
            <li className='item-filter-option' style={{backgroundColor:"#f7aa42"}} onClick={linkHandler}>
              <input type="checkbox"
                    name="category"
                    value="fluo"
                    id="fluo"
                    onChange={handleOnCheckbox} />
                    <label htmlFor="fluo">Artículos Fluo</label>
            </li>
            <li className='item-filter-option' style={{backgroundColor:"#19171c"}} onClick={linkHandler}>
              <input type="checkbox"
                    name="category"
                    value="deluxe"
                    id="deluxe"
                    onChange={handleOnCheckbox} />
                    <label htmlFor="deluxe">Artículos Deluxe</label>
            </li>
            <li className='item-filter-option' style={{backgroundColor:"#e3001b"}} onClick={linkHandler}>
              <input type="checkbox"
                    name="category"
                    value="luminicos"
                    id="luminicos"
                    onChange={handleOnCheckbox} />
                    <label htmlFor="luminicos">Lumínicos</label>
            </li>
            <li className='item-filter-option' style={{backgroundColor:"#008bd0"}} onClick={linkHandler}>
              <input type="checkbox"
                    name="category"
                    value="futbol"
                    id="futbol"
                    onChange={handleOnCheckbox} />
                    <label htmlFor="futbol">Gorros de Fútbol</label>
            </li>
            <li className='item-filter-option' style={{backgroundColor:"#b1c903"}} onClick={linkHandler}>
              <input type="checkbox"
                    name="category"
                    value="vinchas"
                    id="vinchas"
                    onChange={handleOnCheckbox} />
                    <label htmlFor="vinchas">Vinchas</label>
            </li>
            <li className='item-filter-option' style={{backgroundColor:"#a69fc9"}} onClick={linkHandler}>
              <input type="checkbox"
                    name="category"
                    value="accesorios"
                    id="accesorios"
                    onChange={handleOnCheckbox} />
                    <label htmlFor="accesorios">Accesorios</label>
            </li>
          </ul>
        </div>
      </div>
      {
        categoryFiltered.length ?
        (
          filteredItems()
        ) :
        (
          items.length?
          (
            listItems()
          )
          :
          <div className='item-list-container'>
            <div className="loading">
              <span></span>
            </div>
          </div>
        )
      }
    </div>
  )
  
}

export default Productos

